import {ProductIdentifiers} from "@/libs/product";
import {isSustainity} from "@/libs/application";

const sustainity = isSustainity();

export default {
    methods: {
        showRadioForIdentifier(identifier) {
            if (ProductIdentifiers.SUPPLIERS_PRODUCT_ID === identifier.key) {
                return false;
            }
            return ProductIdentifiers.SCIP_NUMBER !== identifier.key;
        },
        isIdentifierVisible(identifierContainer) {
            if (sustainity) {
                if (identifierContainer.item.key === ProductIdentifiers.SCIP_NUMBER) {
                    return false;
                }
                return identifierContainer.item.key !== ProductIdentifiers.SUPPLIERS_SCIP_NUMBER;
            }

            return true;
        }
    }
};
